import styled from 'styled-components';
import Split from 'react-split';

import { colors } from 'global/colors';

export const ResizableRowsContainer = styled(Split)`
  height: 100%;

  & .gutter.gutter-vertical {
    cursor: row-resize;
    background: ${({ theme }) => theme.pageBackground};
    :hover {
      background: ${colors.fsCyan};
    }
  }
`;

export const RowContainer = styled.div`
  overflow: hidden;
  height: 100%;
  width: 100%;
`;
